import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SupportoDirettoWhatsapp() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="supporto-diretto-whatsapp" className="dark bg-background text-foreground relative w-full py-32 overflow-hidden bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1561763/img/modern_home_dusk.png)] bg-cover bg-center bg-no-repeat">
      {}
      <div className="absolute inset-0 bg-black/40" />

      <div ref={ref} className={`relative z-10 container mx-auto px-4 flex flex-col items-center justify-center text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-10 tracking-tight drop-shadow-md">
          Contattaci ora su WhatsApp
        </h2>

        <div className="flex flex-col sm:flex-row items-center gap-6 w-full justify-center">
          {}
          <Button asChild size="lg" className="rounded-full text-lg h-14 px-8 bg-[#25D366] hover:bg-[#25D366]/90 text-white border-none shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
            <Link to="https://wa.me/393349255303" newTab>
              <MessageCircle className="w-6 h-6 mr-2 fill-current" />
              334 9255303
            </Link>
          </Button>

          {}
          <Button asChild size="lg" className="rounded-full text-lg h-14 px-8 bg-primary hover:bg-primary/90 text-white border-none shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
            <Link to="tel:+393349255303">
              <Phone className="w-6 h-6 mr-2 fill-current" />
              Chiamaci ora
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}